module.exports = __webpack_public_path__ + "img/shanghai.325b4d11.png";